import React from "react";

const ErrorOutline = () => (
  <svg viewBox="0 0 100 100">
    <path d="M45 65h10v10H45V65zm0-40h10v30H45V25zm4.95-25C22.35 0 0 22.4 0 50s22.35 50 49.95 50C77.6 100 100 77.6 100 50S77.6 0 49.95 0zM50 90c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z" />
  </svg>
);

export default ErrorOutline;
